import { useEffect, FC } from "react";
import TagManager from "react-gtm-module";
import { useLocation } from "react-router-dom";
import useOneKcId from "web/hooks/useOneKcId";
import { IGtm } from "web/types/Gtm";
import buildGtmPayload from "web/utils/system/GTM/buildGtmPayload";

interface IGtmEvent {
  eventName?: string;
  options: IGtm;
  withUrl?: boolean;
  isReady?: boolean;
}

const GtmEvent: FC<IGtmEvent> = ({ eventName = "virtualPageView", options = {}, withUrl = false, isReady = true }) => {
  const location = useLocation();
  const resolvedOneKcId = useOneKcId();

  useEffect(() => {
    if (isReady) {
      const url = withUrl ? location?.pathname + location?.search : undefined;
      const payload = buildGtmPayload({ eventName, url, options, resolvedOneKcId });

      TagManager.dataLayer({ dataLayer: payload });
    }
  }, [isReady, resolvedOneKcId]);
  return null;
};

export default GtmEvent;
